import React, { useEffect, useState, useContext } from "react";
import Select from "react-select";
import { apiService } from "../../service/ApiService";
import { Form } from "react-bootstrap";
import StoreContext from "contexts/StoreContext";

import { useTranslation } from "react-i18next";

const POSSelect = ({ title, defaultValue = null, handler }) => {
  const {
    t,
  } = useTranslation();

  title = title === undefined ? t("forms.placeholders.selectPos") : title;
  const [pos, setPos] = useState([]);
  const [selectedPos, setSelectedPos] = useState(null);
  const { storeId, setStoreId } = useContext(StoreContext);

  const handleChange = (e) => {
    setSelectedPos(e);
    if (e) handler(e.value);
    else handler(null);
  };

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
  };

  const getPos = async () => {
    try {
      const response = await apiService.get(`api/v1/pos/store/${storeId}`);
      const availablePos = response.map((el) => {
        return {
          value: el.id,
          label: el.name,
        };
      });
      setPos(availablePos);
      setNewValue(null);
    } catch (error) {
      console.error(error);
    }
  };

  const setNewValue = () => {
    const selectedPos = pos.find((el) => el.value === defaultValue);
    if (selectedPos) setSelectedPos(selectedPos);
  };

  useEffect(() => {
    if (!storeId) return;
    getPos();
  }, [storeId]);

  useEffect(() => {
    setNewValue();
  }, [defaultValue]);

  return (
    <>
      <Form.Group>
        <label>{title}</label>
        <Select
          styles={customStyles}
          isClearable={true}
          className="primary"
          name="posSelect"
          onChange={handleChange}
          value={selectedPos}
          options={pos}
          noOptionsMessage={() => t("messages.noPosDevicesAreAvailable")}
          placeholder={title}
        />
      </Form.Group>
    </>
  );
};

export default POSSelect;
